var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_vm._v("成交销售额 "),_c('span',{staticClass:"yx-color-text-primary font-bold"},[_vm._v(_vm._s(_vm.row.total_settle_amount))])]),_c('div',[_vm._v("成交销量 "),_c('span',{staticClass:"yx-color-text-primary font-bold"},[_vm._v(_vm._s(_vm.row.total_settle_item_num))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }